<template lang="html">
<div
  id="p5"
  class="p5"
  ref="p5">
</div>
</template>

<script>
import p5 from 'p5'

export default {
  props: {
    sensorData: {
      required: true
      // default: {
      //   id: null,
      //   orientation: {},
      //   movement: {}
      // }
    }
  },
  data () {
    return {
      sketch: '',
      printOutput: false
    }
  },
  methods: {
    makeSketch () {
      class Ball {
        data
        dotX
        dotY
        dotSize = 10
        dotSpeed = 10

        constructor (id, userData) {
          this.id = id
          this.data = userData
        }

        get orientation () {
          if (this.data.orientation) {
            return this.data.orientation
          }
        }

        setup (p) {
          this.dotX = p.width / 2
          this.dotY = p.height / 2
        }

        update (p, userData) {
          this.data = userData
        }

        draw (p) {
          let dx = 0
          let dy = 0

          if (this.orientation) {
            dx = p.map(this.orientation.gamma, -180, 180, -1, 1) * this.dotSpeed
            dy = p.map(this.orientation.beta, -180, 180, -1, 1) * this.dotSpeed
          }
          dx = dx * this.dotSpeed
          dy = dy * this.dotSpeed

          this.dotX += dx
          this.dotY += dy

          this.dotX = p.constrain(this.dotX, 0, p.width)
          this.dotY = p.constrain(this.dotY, 0, p.height)

          // Map rotationZ directly to dotsize, but smooth values.
          // dotSize = p.map2(buffers['rotationZ'].mean,
          //                  0, 360, 5, p.width / 3, 0.5)

          p.circle(this.dotX, this.dotY, this.dotSize)
        }
      }

      class Balls {
        balls = {}

        constructor (sensorData) {
          this.sensorData = sensorData
        }

        update (p) {
          for (const [channel, userData] of Object.entries(
            this.sensorData)) {
            if (this.balls[channel]) {
              this.balls[channel].update(p, userData)
            } else {
              // New person joined.
              this.balls[channel] = new Ball(channel, userData)
              this.balls[channel].setup(p)
            }
            // FIXME: Need clean up of person leaves.
          }
        }

        draw (p) {
          Object.values(this.balls).forEach((ball) => {
            ball.draw(p)
          })
        }
      }

      const sketch = (p) => {
        p.setup = () => {
          let canvasDiv = this.$refs.p5;
          console.log(canvasDiv);
          let width = canvasDiv.offsetWidth;
          let height = width * (9.0 / 16)

          console.log('width:', width, 'height:', height)
          p.createCanvas(width, height)
          p.frameRate(20)

          this.balls = new Balls(this.sensorData)
        }

        p.draw = () => {
          p.background(255, 255, 255, 100)
          p.fill(255, 255, 255, 50)
          p.fill(0)

          this.balls.update(p)
          this.balls.draw(p)
        }
      }
      return new p5(sketch, 'p5')
    }
  },
  mounted () {
    this.$nextTick(() => {
      // FIXME: P5 errors are not thrown.
      this.sketch = this.makeSketch()
    })
  },
  beforeDestroy () {
    this.sketch.remove()
  }
}
</script>
